import { render, staticRenderFns } from "./DateTab.vue?vue&type=template&id=f0bb0d24&scoped=true"
import script from "./DateTab.vue?vue&type=script&lang=js"
export * from "./DateTab.vue?vue&type=script&lang=js"
import style0 from "./DateTab.vue?vue&type=style&index=0&id=f0bb0d24&prod&lang=scss&scoped=true"
import style1 from "./DateTab.vue?vue&type=style&index=1&id=f0bb0d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bb0d24",
  null
  
)

export default component.exports